import type { ImageToUpload } from '@infield/features/media/types';

export const getMediaSrc = (media: ImageToUpload) => {
  return media.fileUrl ?? URL.createObjectURL(media.url);
};

export const getIsVideo = (media: ImageToUpload) => {
  return media.url.type.includes('video');
};
